var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24943 1.43826C7.51899 0.853912 6.48108 0.853913 5.75065 1.43826L1.37534 4.93851C0.94408 5.28352 0.874158 5.91281 1.21917 6.34407C1.56418 6.77533 2.19347 6.84525 2.62473 6.50024L6.00007 3.79997V11.2768C6.00007 11.8291 6.44779 12.2768 7.00007 12.2768C7.55236 12.2768 8.00007 11.8291 8.00007 11.2768V3.80003L11.3753 6.50024C11.8066 6.84525 12.4359 6.77533 12.7809 6.34407C13.1259 5.91281 13.056 5.28352 12.6247 4.93851L8.24943 1.43826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.029044171577c38cf0444a55359198f8.svg";
export { ForwardRef as ReactComponent };